import requestMaker from 'lib';

export const getFirebaseConfig = () => {
  const baseQuery = `/proxy/cust/px/gfc`;
  const params = {};
  const payload = {};
  return requestMaker(baseQuery, { params, payload });
};

export const setAuthCookie = (payload = {}) => {
  const baseQuery = '/proxy/cust/scks';
  const params = {};
  return requestMaker(baseQuery, { params, payload });
};

export const getAvatarUrl = (payload = {}) => {
  const baseQuery = '/proxy/cust/gau';
  const params = {};
  return requestMaker(baseQuery, { params, payload });
}

export const getSizeRecommendations = (payload = {}) => {
  const baseQuery = '/proxy/cust/gsr';
  const params = {};
  return requestMaker(baseQuery, { params, payload });
}

export const getClothUrl = (payload = {}) => {
  const baseQuery = '/proxy/cust/gcu';
  const params = {};
  return requestMaker(baseQuery, { params, payload });
}

export const getAllAssets = (payload = {}) => {
  const baseQuery = '/proxy/cust/gaa';
  const params = {};
  return requestMaker(baseQuery, { params, payload });
}

export const createToken = (data) => {
  const { uid, ...rest } = data;
  const payload = {
    uid: `${uid}`,
    ...rest
  }
  const baseQuery = '/proxy/cust/cct';
  const params = {};
  return requestMaker(baseQuery, { params, payload });
}

export const sendAnalytics = (payload = {}) => {
  const baseQuery = '/proxy/cust/sa';
  const params = {};
  return requestMaker(baseQuery, { params, payload });
}

export const getProductConfiguration = (payload = {}) => {
  const baseQuery = '/proxy/cust/gpc';
  const params = {};
  return requestMaker(baseQuery, { params, payload });
}

export const predictGarmentSize = (payload = {}) => {
  const baseQuery = "/proxy/cust/pgs";
  const params = {};
  return requestMaker(baseQuery, { params, payload });
};

export const getPepeFunnelDashboard = (payload = {}) => {
  const baseQuery = "/proxy/cust/gpfd";
  const params = {};
  return requestMaker(baseQuery, { params, payload });
};

export const getBrandFunnelDashboard = (payload = {}) => {
  const baseQuery = "/proxy/cust/gpfd";
  const params = {};
  return requestMaker(baseQuery, { params, payload });
};

export const getEnamorFunnelDashboard = (payload = {}) => {
  const baseQuery = "/proxy/cust/gpfd";
  const params = {};
  return requestMaker(baseQuery, {
    params,
    payload: {
      brand: "enamor",
      ...payload,
    },
  });
};

// Live fit-chat → Claude (handled locally by the webproxy at /proxy/cust/fitchat,
// server-side key). payload = { question, context }.
export const fitChat = (payload = {}) => {
  const baseQuery = '/proxy/cust/fitchat';
  return requestMaker(baseQuery, { params: {}, payload });
};
